import { render, staticRenderFns } from "./PromoteItem.vue?vue&type=template&id=9476987e&scoped=true&"
import script from "./PromoteItem.vue?vue&type=script&lang=js&"
export * from "./PromoteItem.vue?vue&type=script&lang=js&"
import style0 from "./PromoteItem.vue?vue&type=style&index=0&id=9476987e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9476987e",
  null
  
)

export default component.exports